/*
 * Copyright 2015-present Palantir Technologies, Inc. All rights reserved.
 */

export type IconName = "add" |
    "add-column-left" |
    "add-column-right" |
    "add-row-bottom" |
    "add-row-top" |
    "add-to-artifact" |
    "add-to-folder" |
    "airplane" |
    "align-center" |
    "align-justify" |
    "align-left" |
    "align-right" |
    "alignment-bottom" |
    "alignment-horizontal-center" |
    "alignment-left" |
    "alignment-right" |
    "alignment-top" |
    "alignment-vertical-center" |
    "annotation" |
    "application" |
    "applications" |
    "arrow-bottom-left" |
    "arrow-bottom-right" |
    "arrow-down" |
    "arrow-left" |
    "arrow-right" |
    "arrow-top-left" |
    "arrow-top-right" |
    "arrow-up" |
    "arrows-horizontal" |
    "arrows-vertical" |
    "asterisk" |
    "automatic-updates" |
    "badge" |
    "ban-circle" |
    "banl-account" |
    "barcode" |
    "blank" |
    "blocked-person" |
    "bold" |
    "book" |
    "bookmark" |
    "box" |
    "briefcase" |
    "build" |
    "calculator" |
    "calendar" |
    "camera" |
    "caret-down" |
    "caret-left" |
    "caret-right" |
    "caret-up" |
    "cell-tower" |
    "changes" |
    "chart" |
    "chat" |
    "chevron-backward" |
    "chevron-down" |
    "chevron-forward" |
    "chevron-left" |
    "chevron-right" |
    "chevron-up" |
    "circle" |
    "circle-arrow-down" |
    "circle-arrow-left" |
    "circle-arrow-right" |
    "circle-arrow-up" |
    "citation" |
    "clipboard" |
    "cloud" |
    "cloud-download" |
    "cloud-upload" |
    "code" |
    "code-block" |
    "cog" |
    "collapse-all" |
    "column-layout" |
    "comment" |
    "comparison" |
    "compressed" |
    "confirm" |
    "contrast" |
    "control" |
    "credit-card" |
    "cross" |
    "curved-range-chart" |
    "cut" |
    "dashboard" |
    "database" |
    "delete" |
    "delta" |
    "derive-column" |
    "desktop" |
    "direction-left" |
    "direction-right" |
    "disable" |
    "document" |
    "document-open" |
    "document-share" |
    "dollar" |
    "dot" |
    "double-caret-horizontal" |
    "double-caret-vertical" |
    "double-chevron-down" |
    "double-chevron-left" |
    "double-chevron-right" |
    "double-chevron-up" |
    "doughnut-chart" |
    "download" |
    "drag-handle-horizontal" |
    "drag-handle-vertical" |
    "draw" |
    "drive-time" |
    "duplicate" |
    "edit" |
    "eject" |
    "endorsed" |
    "envelope" |
    "eraser" |
    "error" |
    "euro" |
    "exchange" |
    "exclude-row" |
    "expand-all" |
    "export" |
    "eye-off" |
    "eye-on" |
    "eye-open" |
    "fast-backward" |
    "fast-forward" |
    "feed" |
    "film" |
    "filter" |
    "filter-list" |
    "flag" |
    "flash" |
    "floppy-disk" |
    "flows" |
    "folder-close" |
    "folder-open" |
    "folder-shared" |
    "folder-shared-open" |
    "follower" |
    "following" |
    "font" |
    "fork" |
    "full-circle" |
    "full-stacked-chart" |
    "fullscreen" |
    "function" |
    "gantt-chart" |
    "geolocation" |
    "geosearch" |
    "git-branch" |
    "git-commit" |
    "git-merge" |
    "git-new-branch" |
    "git-pull" |
    "git-push" |
    "git-repo" |
    "glass" |
    "globe" |
    "graph" |
    "graph-remove" |
    "grid" |
    "grid-view" |
    "group-objects" |
    "grouped-bar-chart" |
    "hand" |
    "hand-down" |
    "hand-left" |
    "hand-right" |
    "hand-up" |
    "header" |
    "headset" |
    "heart" |
    "heat-grid" |
    "heatmap" |
    "help" |
    "helper-management" |
    "highlight" |
    "history" |
    "home" |
    "horizontal-bar-chart" |
    "horizontal-bar-chart-asc" |
    "horizontal-bar-chart-desc" |
    "horizontal-distribution" |
    "id-number" |
    "image-rotate-left" |
    "image-rotate-right" |
    "import" |
    "inbox" |
    "info-sign" |
    "insert" |
    "intersection" |
    "ip-address" |
    "issue" |
    "issue-closed" |
    "issue-new" |
    "italic" |
    "join-table" |
    "key-backspace" |
    "key-command" |
    "key-control" |
    "key-delete" |
    "key-enter" |
    "key-escape" |
    "key-option" |
    "key-shift" |
    "key-tab" |
    "known-vehicle" |
    "label" |
    "layer" |
    "layers" |
    "layout" |
    "layout-auto" |
    "layout-balloon" |
    "layout-circle" |
    "layout-grid" |
    "layout-group-by" |
    "layout-hierarchy" |
    "layout-linear" |
    "layout-skew-grid" |
    "layout-sorted-clusters" |
    "lightbulb" |
    "link" |
    "list" |
    "list-detail-view" |
    "locate" |
    "lock" |
    "log-in" |
    "log-out" |
    "manual" |
    "manually-entered-data" |
    "map" |
    "map-create" |
    "map-marker" |
    "maximize" |
    "media" |
    "menu" |
    "menu-closed" |
    "menu-open" |
    "merge-columns" |
    "merge-links" |
    "minimize" |
    "minus" |
    "mobile-phone" |
    "mobile-video" |
    "moon" |
    "more" |
    "move" |
    "mugshot" |
    "multi-select" |
    "music" |
    "new-grid-item" |
    "new-link" |
    "new-object" |
    "new-person" |
    "new-prescription" |
    "new-text-box" |
    "ninja" |
    "notifications" |
    "numbered-list" |
    "numerical" |
    "office" |
    "offline" |
    "oil-field" |
    "one-column" |
    "page-layout" |
    "panel-stats" |
    "panel-table" |
    "paperclip" |
    "paragraph" |
    "path" |
    "path-search" |
    "pause" |
    "people" |
    "percentage" |
    "person" |
    "phone" |
    "pie-chart" |
    "pin" |
    "pivot" |
    "pivot-table" |
    "play" |
    "plus" |
    "polygon-filter" |
    "power" |
    "predictive-analysis" |
    "prescription" |
    "presentation" |
    "print" |
    "projects" |
    "properties" |
    "property" |
    "pt-icon-add" |
    "pt-icon-add-column-left" |
    "pt-icon-add-column-right" |
    "pt-icon-add-row-bottom" |
    "pt-icon-add-row-top" |
    "pt-icon-add-to-artifact" |
    "pt-icon-add-to-folder" |
    "pt-icon-airplane" |
    "pt-icon-align-center" |
    "pt-icon-align-justify" |
    "pt-icon-align-left" |
    "pt-icon-align-right" |
    "pt-icon-alignment-bottom" |
    "pt-icon-alignment-horizontal-center" |
    "pt-icon-alignment-left" |
    "pt-icon-alignment-right" |
    "pt-icon-alignment-top" |
    "pt-icon-alignment-vertical-center" |
    "pt-icon-annotation" |
    "pt-icon-application" |
    "pt-icon-applications" |
    "pt-icon-arrow-bottom-left" |
    "pt-icon-arrow-bottom-right" |
    "pt-icon-arrow-down" |
    "pt-icon-arrow-left" |
    "pt-icon-arrow-right" |
    "pt-icon-arrow-top-left" |
    "pt-icon-arrow-top-right" |
    "pt-icon-arrow-up" |
    "pt-icon-arrows-horizontal" |
    "pt-icon-arrows-vertical" |
    "pt-icon-asterisk" |
    "pt-icon-automatic-updates" |
    "pt-icon-badge" |
    "pt-icon-ban-circle" |
    "pt-icon-banl-account" |
    "pt-icon-barcode" |
    "pt-icon-blank" |
    "pt-icon-blocked-person" |
    "pt-icon-bold" |
    "pt-icon-book" |
    "pt-icon-bookmark" |
    "pt-icon-box" |
    "pt-icon-briefcase" |
    "pt-icon-build" |
    "pt-icon-calculator" |
    "pt-icon-calendar" |
    "pt-icon-camera" |
    "pt-icon-caret-down" |
    "pt-icon-caret-left" |
    "pt-icon-caret-right" |
    "pt-icon-caret-up" |
    "pt-icon-cell-tower" |
    "pt-icon-changes" |
    "pt-icon-chart" |
    "pt-icon-chat" |
    "pt-icon-chevron-backward" |
    "pt-icon-chevron-down" |
    "pt-icon-chevron-forward" |
    "pt-icon-chevron-left" |
    "pt-icon-chevron-right" |
    "pt-icon-chevron-up" |
    "pt-icon-circle" |
    "pt-icon-circle-arrow-down" |
    "pt-icon-circle-arrow-left" |
    "pt-icon-circle-arrow-right" |
    "pt-icon-circle-arrow-up" |
    "pt-icon-citation" |
    "pt-icon-clipboard" |
    "pt-icon-cloud" |
    "pt-icon-cloud-download" |
    "pt-icon-cloud-upload" |
    "pt-icon-code" |
    "pt-icon-code-block" |
    "pt-icon-cog" |
    "pt-icon-collapse-all" |
    "pt-icon-column-layout" |
    "pt-icon-comment" |
    "pt-icon-comparison" |
    "pt-icon-compressed" |
    "pt-icon-confirm" |
    "pt-icon-contrast" |
    "pt-icon-control" |
    "pt-icon-credit-card" |
    "pt-icon-cross" |
    "pt-icon-curved-range-chart" |
    "pt-icon-cut" |
    "pt-icon-dashboard" |
    "pt-icon-database" |
    "pt-icon-delete" |
    "pt-icon-delta" |
    "pt-icon-derive-column" |
    "pt-icon-desktop" |
    "pt-icon-direction-left" |
    "pt-icon-direction-right" |
    "pt-icon-disable" |
    "pt-icon-document" |
    "pt-icon-document-open" |
    "pt-icon-document-share" |
    "pt-icon-dollar" |
    "pt-icon-dot" |
    "pt-icon-double-caret-horizontal" |
    "pt-icon-double-caret-vertical" |
    "pt-icon-double-chevron-down" |
    "pt-icon-double-chevron-left" |
    "pt-icon-double-chevron-right" |
    "pt-icon-double-chevron-up" |
    "pt-icon-doughnut-chart" |
    "pt-icon-download" |
    "pt-icon-drag-handle-horizontal" |
    "pt-icon-drag-handle-vertical" |
    "pt-icon-draw" |
    "pt-icon-drive-time" |
    "pt-icon-duplicate" |
    "pt-icon-edit" |
    "pt-icon-eject" |
    "pt-icon-endorsed" |
    "pt-icon-envelope" |
    "pt-icon-eraser" |
    "pt-icon-error" |
    "pt-icon-euro" |
    "pt-icon-exchange" |
    "pt-icon-exclude-row" |
    "pt-icon-expand-all" |
    "pt-icon-export" |
    "pt-icon-eye-off" |
    "pt-icon-eye-on" |
    "pt-icon-eye-open" |
    "pt-icon-fast-backward" |
    "pt-icon-fast-forward" |
    "pt-icon-feed" |
    "pt-icon-film" |
    "pt-icon-filter" |
    "pt-icon-filter-list" |
    "pt-icon-flag" |
    "pt-icon-flash" |
    "pt-icon-floppy-disk" |
    "pt-icon-flows" |
    "pt-icon-folder-close" |
    "pt-icon-folder-open" |
    "pt-icon-folder-shared" |
    "pt-icon-folder-shared-open" |
    "pt-icon-follower" |
    "pt-icon-following" |
    "pt-icon-font" |
    "pt-icon-fork" |
    "pt-icon-full-circle" |
    "pt-icon-full-stacked-chart" |
    "pt-icon-fullscreen" |
    "pt-icon-function" |
    "pt-icon-gantt-chart" |
    "pt-icon-geolocation" |
    "pt-icon-geosearch" |
    "pt-icon-git-branch" |
    "pt-icon-git-commit" |
    "pt-icon-git-merge" |
    "pt-icon-git-new-branch" |
    "pt-icon-git-pull" |
    "pt-icon-git-push" |
    "pt-icon-git-repo" |
    "pt-icon-glass" |
    "pt-icon-globe" |
    "pt-icon-graph" |
    "pt-icon-graph-remove" |
    "pt-icon-grid" |
    "pt-icon-grid-view" |
    "pt-icon-group-objects" |
    "pt-icon-grouped-bar-chart" |
    "pt-icon-hand" |
    "pt-icon-hand-down" |
    "pt-icon-hand-left" |
    "pt-icon-hand-right" |
    "pt-icon-hand-up" |
    "pt-icon-header" |
    "pt-icon-headset" |
    "pt-icon-heart" |
    "pt-icon-heat-grid" |
    "pt-icon-heatmap" |
    "pt-icon-help" |
    "pt-icon-helper-management" |
    "pt-icon-highlight" |
    "pt-icon-history" |
    "pt-icon-home" |
    "pt-icon-horizontal-bar-chart" |
    "pt-icon-horizontal-bar-chart-asc" |
    "pt-icon-horizontal-bar-chart-desc" |
    "pt-icon-horizontal-distribution" |
    "pt-icon-id-number" |
    "pt-icon-image-rotate-left" |
    "pt-icon-image-rotate-right" |
    "pt-icon-import" |
    "pt-icon-inbox" |
    "pt-icon-info-sign" |
    "pt-icon-insert" |
    "pt-icon-intersection" |
    "pt-icon-ip-address" |
    "pt-icon-issue" |
    "pt-icon-issue-closed" |
    "pt-icon-issue-new" |
    "pt-icon-italic" |
    "pt-icon-join-table" |
    "pt-icon-key-backspace" |
    "pt-icon-key-command" |
    "pt-icon-key-control" |
    "pt-icon-key-delete" |
    "pt-icon-key-enter" |
    "pt-icon-key-escape" |
    "pt-icon-key-option" |
    "pt-icon-key-shift" |
    "pt-icon-key-tab" |
    "pt-icon-known-vehicle" |
    "pt-icon-label" |
    "pt-icon-layer" |
    "pt-icon-layers" |
    "pt-icon-layout" |
    "pt-icon-layout-auto" |
    "pt-icon-layout-balloon" |
    "pt-icon-layout-circle" |
    "pt-icon-layout-grid" |
    "pt-icon-layout-group-by" |
    "pt-icon-layout-hierarchy" |
    "pt-icon-layout-linear" |
    "pt-icon-layout-skew-grid" |
    "pt-icon-layout-sorted-clusters" |
    "pt-icon-lightbulb" |
    "pt-icon-link" |
    "pt-icon-list" |
    "pt-icon-list-detail-view" |
    "pt-icon-locate" |
    "pt-icon-lock" |
    "pt-icon-log-in" |
    "pt-icon-log-out" |
    "pt-icon-manual" |
    "pt-icon-manually-entered-data" |
    "pt-icon-map" |
    "pt-icon-map-create" |
    "pt-icon-map-marker" |
    "pt-icon-maximize" |
    "pt-icon-media" |
    "pt-icon-menu" |
    "pt-icon-menu-closed" |
    "pt-icon-menu-open" |
    "pt-icon-merge-columns" |
    "pt-icon-merge-links" |
    "pt-icon-minimize" |
    "pt-icon-minus" |
    "pt-icon-mobile-phone" |
    "pt-icon-mobile-video" |
    "pt-icon-moon" |
    "pt-icon-more" |
    "pt-icon-move" |
    "pt-icon-mugshot" |
    "pt-icon-multi-select" |
    "pt-icon-music" |
    "pt-icon-new-grid-item" |
    "pt-icon-new-link" |
    "pt-icon-new-object" |
    "pt-icon-new-person" |
    "pt-icon-new-prescription" |
    "pt-icon-new-text-box" |
    "pt-icon-ninja" |
    "pt-icon-notifications" |
    "pt-icon-numbered-list" |
    "pt-icon-numerical" |
    "pt-icon-office" |
    "pt-icon-offline" |
    "pt-icon-oil-field" |
    "pt-icon-one-column" |
    "pt-icon-page-layout" |
    "pt-icon-panel-stats" |
    "pt-icon-panel-table" |
    "pt-icon-paperclip" |
    "pt-icon-paragraph" |
    "pt-icon-path" |
    "pt-icon-path-search" |
    "pt-icon-pause" |
    "pt-icon-people" |
    "pt-icon-percentage" |
    "pt-icon-person" |
    "pt-icon-phone" |
    "pt-icon-pie-chart" |
    "pt-icon-pin" |
    "pt-icon-pivot" |
    "pt-icon-pivot-table" |
    "pt-icon-play" |
    "pt-icon-plus" |
    "pt-icon-polygon-filter" |
    "pt-icon-power" |
    "pt-icon-predictive-analysis" |
    "pt-icon-prescription" |
    "pt-icon-presentation" |
    "pt-icon-print" |
    "pt-icon-projects" |
    "pt-icon-properties" |
    "pt-icon-property" |
    "pt-icon-publish-function" |
    "pt-icon-pulse" |
    "pt-icon-random" |
    "pt-icon-record" |
    "pt-icon-redo" |
    "pt-icon-refresh" |
    "pt-icon-regression-chart" |
    "pt-icon-remove" |
    "pt-icon-remove-column" |
    "pt-icon-remove-column-left" |
    "pt-icon-remove-column-right" |
    "pt-icon-remove-row-bottom" |
    "pt-icon-remove-row-top" |
    "pt-icon-repeat" |
    "pt-icon-resolve" |
    "pt-icon-rig" |
    "pt-icon-ring" |
    "pt-icon-rotate-document" |
    "pt-icon-rotate-page" |
    "pt-icon-satellite" |
    "pt-icon-saved" |
    "pt-icon-scatter-plot" |
    "pt-icon-search" |
    "pt-icon-search-around" |
    "pt-icon-search-template" |
    "pt-icon-search-text" |
    "pt-icon-segmented-control" |
    "pt-icon-select" |
    "pt-icon-selection" |
    "pt-icon-send-to" |
    "pt-icon-send-to-graph" |
    "pt-icon-send-to-map" |
    "pt-icon-settings" |
    "pt-icon-share" |
    "pt-icon-shop" |
    "pt-icon-shopping-cart" |
    "pt-icon-sim-card" |
    "pt-icon-slash" |
    "pt-icon-small-cross" |
    "pt-icon-small-minus" |
    "pt-icon-small-plus" |
    "pt-icon-small-tick" |
    "pt-icon-social-media" |
    "pt-icon-sort" |
    "pt-icon-sort-alphabetical" |
    "pt-icon-sort-alphabetical-desc" |
    "pt-icon-sort-asc" |
    "pt-icon-sort-desc" |
    "pt-icon-sort-numerical" |
    "pt-icon-sort-numerical-desc" |
    "pt-icon-split-columns" |
    "pt-icon-square" |
    "pt-icon-stacked-chart" |
    "pt-icon-star" |
    "pt-icon-star-empty" |
    "pt-icon-step-backward" |
    "pt-icon-step-chart" |
    "pt-icon-step-forward" |
    "pt-icon-stop" |
    "pt-icon-style" |
    "pt-icon-swap-horizontal" |
    "pt-icon-swap-vertical" |
    "pt-icon-symbol-circle" |
    "pt-icon-symbol-cross" |
    "pt-icon-symbol-diamond" |
    "pt-icon-symbol-square" |
    "pt-icon-symbol-triangle-down" |
    "pt-icon-symbol-triangle-up" |
    "pt-icon-tag" |
    "pt-icon-take-action" |
    "pt-icon-text-highlight" |
    "pt-icon-th" |
    "pt-icon-th-derived" |
    "pt-icon-th-list" |
    "pt-icon-thumbs-down" |
    "pt-icon-thumbs-up" |
    "pt-icon-tick" |
    "pt-icon-tick-circle" |
    "pt-icon-time" |
    "pt-icon-timeline-area-chart" |
    "pt-icon-timeline-bar-chart" |
    "pt-icon-timeline-events" |
    "pt-icon-timeline-line-chart" |
    "pt-icon-tint" |
    "pt-icon-torch" |
    "pt-icon-translate" |
    "pt-icon-trash" |
    "pt-icon-trending-down" |
    "pt-icon-trending-up" |
    "pt-icon-two-columns" |
    "pt-icon-underline" |
    "pt-icon-undo" |
    "pt-icon-ungroup-objects" |
    "pt-icon-unknown-vehicle" |
    "pt-icon-unlock" |
    "pt-icon-unpin" |
    "pt-icon-unresolve" |
    "pt-icon-upload" |
    "pt-icon-user" |
    "pt-icon-variable" |
    "pt-icon-vertical-bar-chart-asc" |
    "pt-icon-vertical-bar-chart-desc" |
    "pt-icon-vertical-distribution" |
    "pt-icon-video" |
    "pt-icon-volume-down" |
    "pt-icon-volume-off" |
    "pt-icon-volume-up" |
    "pt-icon-warning-sign" |
    "pt-icon-waterfall-chart" |
    "pt-icon-widget" |
    "pt-icon-wrench" |
    "pt-icon-zoom-in" |
    "pt-icon-zoom-out" |
    "pt-icon-zoom-to-fit" |
    "publish-function" |
    "pulse" |
    "random" |
    "record" |
    "redo" |
    "refresh" |
    "regression-chart" |
    "remove" |
    "remove-column" |
    "remove-column-left" |
    "remove-column-right" |
    "remove-row-bottom" |
    "remove-row-top" |
    "repeat" |
    "resolve" |
    "rig" |
    "ring" |
    "rotate-document" |
    "rotate-page" |
    "satellite" |
    "saved" |
    "scatter-plot" |
    "search" |
    "search-around" |
    "search-template" |
    "search-text" |
    "segmented-control" |
    "select" |
    "selection" |
    "send-to" |
    "send-to-graph" |
    "send-to-map" |
    "settings" |
    "share" |
    "shop" |
    "shopping-cart" |
    "sim-card" |
    "slash" |
    "small-cross" |
    "small-minus" |
    "small-plus" |
    "small-tick" |
    "social-media" |
    "sort" |
    "sort-alphabetical" |
    "sort-alphabetical-desc" |
    "sort-asc" |
    "sort-desc" |
    "sort-numerical" |
    "sort-numerical-desc" |
    "split-columns" |
    "square" |
    "stacked-chart" |
    "star" |
    "star-empty" |
    "step-backward" |
    "step-chart" |
    "step-forward" |
    "stop" |
    "style" |
    "swap-horizontal" |
    "swap-vertical" |
    "symbol-circle" |
    "symbol-cross" |
    "symbol-diamond" |
    "symbol-square" |
    "symbol-triangle-down" |
    "symbol-triangle-up" |
    "tag" |
    "take-action" |
    "text-highlight" |
    "th" |
    "th-derived" |
    "th-list" |
    "thumbs-down" |
    "thumbs-up" |
    "tick" |
    "tick-circle" |
    "time" |
    "timeline-area-chart" |
    "timeline-bar-chart" |
    "timeline-events" |
    "timeline-line-chart" |
    "tint" |
    "torch" |
    "translate" |
    "trash" |
    "trending-down" |
    "trending-up" |
    "two-columns" |
    "underline" |
    "undo" |
    "ungroup-objects" |
    "unknown-vehicle" |
    "unlock" |
    "unpin" |
    "unresolve" |
    "upload" |
    "user" |
    "variable" |
    "vertical-bar-chart-asc" |
    "vertical-bar-chart-desc" |
    "vertical-distribution" |
    "video" |
    "volume-down" |
    "volume-off" |
    "volume-up" |
    "warning-sign" |
    "waterfall-chart" |
    "widget" |
    "wrench" |
    "zoom-in" |
    "zoom-out" |
    "zoom-to-fit";
